import binoculars from './binoculars.jpg';
import book from './book.png';
import brain from './brain.png';
import briefcase from './briefcase.png';
import cat from './cat.png';
import cheese from './cheese.png';
import crosseyed from './crosseyed.jpg';
import eyes from './eyes.png';
import hands from './hands.png';
import handstand from './handstand.png';
import hearing from './hearing.png';
import heart from './heart.png';
import hotdog from './hotdog.png';
import microphone from './microphone.png';
import money from './money.png';
import pointer from './pointer.png';
import respect from './respect.png';
import sausage from './sausage.png';
import search from './search.png';
import slippers from './slippers.png';
import star from './star.png';
import tire from './tire.jpg';
import trophy from './trophy.png';

const icons = {
    binoculars,
    book,
    brain,
    briefcase,
    cat,
    cheese,
    crosseyed,
    eyes,
    hands,
    handstand,
    hearing,
    heart,
    hotdog,
    microphone,
    money,
    pointer,
    respect,
    sausage,
    search,
    slippers,
    star,
    tire,
    trophy,
};

export default icons;
